import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import SecureDataflowService from "@/services/secureDataflowService";
import moment from "moment"

const m0checklistApi = AiseaApiFactory.get("m0checklist");
const m0checklistRoomApi = AiseaApiFactory.get("m0checklistRoom");
const roomApi = AiseaApiFactory.get("room");
const euApi = AiseaApiFactory.get("enterpriseUser");

export default {

    /**
     *  チェックリスト一覧を検索.
     */
    async searchDataRecordList(_nouse , timeValueJST) {

      let vessel = await SecureDataflowService.getVessel();
      const params = {
        year_month: moment(timeValueJST).format("YYYY-MM"),
      };
      let res = await m0checklistApi.searchCheckList(vessel.vessel_info.id, params);

      let recordList = res.data.m0_checklists.map(m0_checklist => {
        return {
          id: m0_checklist.id,
          start_at: moment(m0_checklist.start_at).local().format("YYYY/MM/DD HH:mm"),
          version_id: m0_checklist.version_id,
        };
      });

      // start_atでソート
      recordList.sort((a, b) => {
        let comparison = 0;
        if (a.start_at > b.start_at) {
          comparison = 1;
        } else if (a.start_at < b.start_at) {
          comparison = -1;
        }
        return comparison;
      });

      return recordList;
    },


    /**
     *  チェックリスト詳細を検索.
     * 
     *   SET_ROOM_MASTERS_MAP
     *   SET_ROOM_DATAS
     *   SET_SELECTED_ROOM_ID
     *   SET_ITEM_FRAME_MAP_MAP
     *   SET_EDIT_HISTORY_LIST_MAP
     *   SET_ITEM_VALUE_LIST_HISTORY_MAP_MAP
     * 
     */
    async searchM0CheckListItems({ dispatch }, m0CheckList) {

      // ルームマスタ情報のチェック
      await dispatch("prepareRoomMasters", m0CheckList.version_id);

      // APIコール.
      // 必要な情報（room,group,itemの名称、item check_dataの履歴など）を一括で取得できる。
      let res = await m0checklistRoomApi.searchCheckListItemValues(m0CheckList.id, m0CheckList.version_id);

      // 一括で取得した情報を各分野の情報として保存.
      await Promise.all([
        dispatch("setRoomDatasAndId", res.data),
        dispatch("setItemFrame",      res.data),
        dispatch("setEditHistory",    res.data),
        dispatch("setItemValue",      res.data)
      ]);

    },
    async setRoomDatasAndId({ commit, state }, payload) {
      // そのチェックリストのRoom情報を生成し、commit

      let roomDatas = new Array();
      const versionId = payload.m0_rooms[0].version_id;
      const roomMasters = state.roomMastersMap[versionId];

      if ( roomMasters ) {
        // そのチェックリストのrooms情報を生成し、commit
        roomDatas = roomMasters.map(roomMaster => {
          let roomData = Object.assign({},roomMaster);
          roomData.isActive = false;

          let matchedRoom = payload.m0_rooms.find(room => Number(room.room_id) === Number(roomMaster.room_id));

          if( matchedRoom ) {
            roomData.isActive = true;
            roomData.room_name = matchedRoom.room_name;
            roomData.is_checked_weekly = matchedRoom.is_checked_weekly; // true:週次, false:日次
          }
          return roomData;
        });

        // is_checked_weekly, order_number でソート
        roomDatas.sort((a, b) => {
          let comparison = 0;
          let aCheckedWeekly = a.is_checked_weekly ? 1 : 0;
          let bCheckedWeekly = b.is_checked_weekly ? 1 : 0;
          if (aCheckedWeekly > bCheckedWeekly) {
            comparison = 1;
          } else if (aCheckedWeekly < bCheckedWeekly) {
            comparison = -1;
          } else if (a.order_number > b.order_number) {
            comparison = 1;
          } else if (a.order_number < b.order_number) {
            comparison = -1;
          }
          return comparison;
        });
      }

      commit("SET_ROOM_DATAS", roomDatas);
      commit("SET_SELECTED_ROOM_ID", (roomDatas.length > 0 ? roomDatas[0].room_id : -1));
    },
    async setItemFrame({ commit }, payload) {
      // そのチェックリストのFrame情報を生成し、commit

      let itemFrameMapMap = {};
      payload.m0_rooms.forEach(m0_room => {
        let itemFrameMap = {};
        m0_room.m0_groups.forEach(m0_group => {
          m0_group.m0_items.forEach(m0_item => {
            let itemFrame = {
              item_id:                   m0_item.item_id,
              room_id:                   m0_room.room_id,
              group_id:                  m0_group.group_id,
              group_name:                m0_group.group_name,
              item_name:                 m0_item.item_name,
              unit:                      m0_item.unit,
              value_normal:              m0_item.value_normal,
              value_string_option:       m0_item.value_string_option,
              value_number_round_digits: m0_item.value_number_round_digits,
              order_number:              m0_item.order_number,
            };
            // item_idが第２キー
            itemFrameMap[m0_item.item_id] = itemFrame;
          });
        });
        // room_idが第１キー
        itemFrameMapMap[m0_room.room_id] = itemFrameMap;
      });

      commit("SET_ITEM_FRAME_MAP_MAP", itemFrameMapMap);
    },
    async setEditHistory({ commit }, payload) {
      // m0_checklist_rooms側を使って、編集履歴を生成し、commit;

      // 社員名を確保。
      let enterpriseUsersMapCache = {};
      let resEnterpriseUser = await euApi.search();
      if ( resEnterpriseUser.data ) {
        resEnterpriseUser.data.users.forEach(user => {
          enterpriseUsersMapCache[user.id] = user;
        });
      }

      let editHistoryListMap = {};
      for ( const roomId of Object.keys(payload.m0_checklist_rooms) ) {
        let editHistoryList = [];
        let m0_checklist_room_history_list = payload.m0_checklist_rooms[roomId];

        m0_checklist_room_history_list.forEach(history => {
          let editHistory = {
            editHistoryId: history.m0_checklist_room_id, 
            savedAt:       history.m0_saved_at, 
            userId:        history.m0_enterprise_user_id,
            userName:      enterpriseUsersMapCache[history.m0_enterprise_user_id] ? enterpriseUsersMapCache[history.m0_enterprise_user_id].name : "",
          };
          editHistoryList.push(editHistory);
        });

        editHistoryListMap[roomId] = editHistoryList;
      }
      commit("SET_EDIT_HISTORY_LIST_MAP", editHistoryListMap);
    },
    async setItemValue({ commit }, payload) {
      // m0_checklist_rooms側を使って、item情報とそれに紐づく値の履歴のセットを生成し、commit;

      let itemValueListHistoryMapMap = {};
      for ( const roomId of Object.keys(payload.m0_checklist_rooms)) {
        let itemValueListHistoryMap = {};
        let m0_checklist_room_history_list = payload.m0_checklist_rooms[roomId];

        m0_checklist_room_history_list.forEach(history => {
          let itemValueListHistory = [];
          itemValueListHistory = history.m0_check_data;
          // リビジョンIDが第２キー
          itemValueListHistoryMap[history.m0_checklist_room_id] = itemValueListHistory;

        });
        // ルームIDが第１キー
        itemValueListHistoryMapMap[roomId] = itemValueListHistoryMap;
      }
      commit("SET_ITEM_VALUE_LIST_HISTORY_MAP_MAP", itemValueListHistoryMapMap);
    }, 


    /**
     *  チェックリストの中で、roomId と editHistoryId が確定したら、item枠とitem値をマージして詳細リストを生成.
     */
    async mergeItemFrameValue({ state }, selectedEditHistoryId) {

      if( ! selectedEditHistoryId ) {
        if (state.editHistoryListMap[state.selectedRoomId] && state.editHistoryListMap[state.selectedRoomId].length > 0 ) {
          // デフォルトは最新の版を当てる。(JSONは降順で来ているので、０番が最新)
          selectedEditHistoryId = state.editHistoryListMap[state.selectedRoomId][0].editHistoryId;
        }
      }

      let itemFrameMap = state.itemFrameMapMap[state.selectedRoomId];
      let itemValueList = state.itemValueListHistoryMapMap[state.selectedRoomId] && state.itemValueListHistoryMapMap[state.selectedRoomId][selectedEditHistoryId]
            ? state.itemValueListHistoryMapMap[state.selectedRoomId][selectedEditHistoryId]
            : new Array();

      // itemFlameをベースにitemValueを付与
      let itemDispList = new Array();
      if ( itemFrameMap ) {
        let itemFrameList = Object.keys(itemFrameMap).map(key => itemFrameMap[key]);
        itemFrameList.forEach(itemFrame => {
          let itemDisp = Object.assign({},itemFrame);
          let matchedItemValue = itemValueList.find(itemValue => itemValue.m0_item_id === itemFrame.item_id);
          if ( matchedItemValue ) {
            itemDisp.value_string =  matchedItemValue.m0_value_string;
            itemDisp.value_number =  matchedItemValue.m0_value_number;
            itemDisp.checked_at   =  matchedItemValue.m0_checked_at;
          }
          itemDispList.push(itemDisp);
        });
      }

      return itemDispList;
    },


    /**
     * ルームマスタ情報のチェック. ルームマスタ情報がなければ取得.
     */
    async prepareRoomMasters({ commit, state }, versionId) {

      if ( ! state.roomMastersMap[versionId] || state.roomMastersMap[versionId].length <= 0 ) {
        let vessel = await SecureDataflowService.getVessel();
        let roomMasterRes = await roomApi.getCheckListRooms(vessel.vessel_info.id, versionId);

        let roomMasters = roomMasterRes.data.m0_rooms.map(room => {
          return {
            room_id: room.room_id,
            version_id: room.version_id,
            room_name: room.room_name,
            is_checked_weekly: room.is_checked_weekly,
            order_number: room.order_number,
          };
        });
  
        // order_number でソート
        roomMasters.sort((a, b) => {
          let comparison = 0;
          if (a.order_number > b.order_number) {
            comparison = 1;
          } else if (a.order_number < b.order_number) {
            comparison = -1;
          }
          return comparison;
        });
  
        await commit("SET_ROOM_MASTERS_MAP", roomMasters);
      }
    },

    /**
     * M0チェックリスト印刷用PDFファイルのソースを取得.
     * 
     */
    async getM0CheckListForPdf(_nouse, m0ChecklistId) {
      let res = await m0checklistApi.getM0ChecklistHtml(m0ChecklistId);
      return res.data;
    },

    async setSelectedM0CheckListId({ commit }, data) {
      commit("SET_SELECTED_M0_CHECK_LIST_ID", data);
    },

    async setSelectedRoomId({ commit }, data) {
      commit("SET_SELECTED_ROOM_ID", data);
    },

    async setSelectedEditHistoryId({ commit }, data) {
      commit("SET_SELECTED_EDIT_HISTORY_ID", data);
    },

    async setRoomDatas({ commit }, data) {
      commit("SET_ROOM_DATAS", data);
    },

}